var icon = require('vue-svgicon')
icon.register({
  'ks-icon-new-tab': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M71.33 31v7.33H84.5l-36 36.05 5.17 5.17 36.05-36v13.12H97V31m-7.33 58.67H38.33V38.33H64V31H38.33A7.33 7.33 0 0 0 31 38.33v51.34A7.33 7.33 0 0 0 38.33 97h51.34A7.33 7.33 0 0 0 97 89.67V64h-7.33z"/>'
  }
})
